import { createXRStore } from "@react-three/xr";

export const xrStore = createXRStore();

export const TEX = {
  earthDay: "https://unpkg.com/three-globe@2.45.2/example/img/earth-blue-marble.jpg",
  earthNight: "https://unpkg.com/three-globe@2.45.2/example/img/earth-night.jpg",
  earthBump: "https://unpkg.com/three-globe@2.45.2/example/img/earth-topology.png",
  moon: "https://raw.githubusercontent.com/mrdoob/three.js/r169/examples/textures/planets/moon_1024.jpg",
};
